const MOD = 'CORE/HASH/'
export const HSET = `${MOD}HSET`
export const HSETNX = `${MOD}HSETNX`
export const HMSET = `${MOD}HMSET`
export const HINCRBY = `${MOD}HINCRBY`
export const HTOGGLE = `${MOD}HTOGGLE`
export const HDEL = `${MOD}HDEL`
export const HDELALL = `${MOD}HDELALL`



// WEBPACK FOOTER //
// ./src/modules/hash/actionTypes.js